<template>
  <v-snackbar
    :time="time"
    :color="type"
    top
    right
    v-model="active"
    transition="slide-x-reverse-transition"
  >
    <v-icon class="mr-1">mdi- {{ icon() }}</v-icon> {{ text }}
  </v-snackbar>
</template>
<script>
import { events } from "./events";
export default {
  data() {
    return {
      active: false,
      type: "",
      time: 5000,
      text: "",
      retype: {
        success: "checkbox-marked-circle",
        info: "information-outline",
        warning: "alert-outline",
        error: "alert-remove",
      },
    };
  },

  mounted() {
    events.$on("add", this.show);
  },

  methods: {
    show({ type, text, time = 5000 }) {
      this.type = type;
      this.text = text;
      this.time = time;
      this.active = true;
    },

    icon() {
      return `mdi-${this.retype[this.type]}`;
    },
  },
};
</script>
<style scoped>
.teste {
  position: absolute;
}
</style>
